import { render, staticRenderFns } from "./consultationDetail.vue?vue&type=template&id=3e96636c&scoped=true&"
import script from "./consultationDetail.vue?vue&type=script&lang=js&"
export * from "./consultationDetail.vue?vue&type=script&lang=js&"
import style0 from "./consultationDetail.vue?vue&type=style&index=0&id=3e96636c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96636c",
  null
  
)

export default component.exports